import { Component, OnInit, Input } from '@angular/core';
import { APIService } from '../../api.service';

@Component({
  selector: 'app-select-executive',
  templateUrl: './select-executive.component.html',
  styleUrls: ['./select-executive.component.scss']
})
export class SelectExecutiveComponent implements OnInit {

  @Input() mdlRef: any;
  @Input() id: number = 0;

  selected = {
    name: '',
    id: 0
  }
  executives: any = [];

  constructor( private apiService: APIService ) { }

  ngOnInit(): void {
    // let tblJ = this.apiService.getCookie("J");

    // if(tblJ) {
    //   let tmpTblJ = JSON.parse(tblJ);
    //   this.executives = tmpTblJ;
    // }

    // if(this.id > 0) {
    //   this.selected.id = this.id;
    // }

    let tblJ = this.apiService.getCookie("J");

    if(tblJ) {
      let tmpTblJ = JSON.parse(tblJ);
      this.executives = tmpTblJ;

      if(this.executives.length == 1){
        this.selected.id = this.executives[0].UserID;
      }
      else{
        this.selected.id = 0;
      } 
    }

  }

  passBack() {
    this.mdlRef.close();
  }

  save() {
    if(this.selected.id == 0) {
      this.apiService.successAlert('Please select executive.');
      return;
    }
    else {
      let selCust = [];
      selCust = this.executives.filter((a: any) => a.UserID == this.selected.id );
      
      this.mdlRef.close(selCust);
    }
  }

}
